import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {OffersComponent} from './offers.component';
import {CreateOfferComponent} from './create-offer/create-offer.component';
import {EditOfferComponent} from './edit-offer/edit-offer.component';
import {ListOfferComponent} from './list-offer/list-offer.component';
import {ViewOfferComponent} from './view-offer/view-offer.component';
import {UserRolesGuardsService} from '../../../shared/guards/user-roles-guards.service';

const offersRoute: Routes = [
    {
        path: '',
        component: OffersComponent,
        children: [
            {
                path: 'adauga-oferta',
                component: CreateOfferComponent
            },
            {
                path: 'oferta/:id',
                component: ViewOfferComponent
            },
            {
                path: 'editare-oferta/:id',
                component: EditOfferComponent
            },
            {
                path: 'lista-oferte',
                component: ListOfferComponent
            },
            { path: '', redirectTo: '/', pathMatch: 'full' },
            {
                path: '**',
                redirectTo: '/',
                pathMatch: 'full',
            }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forChild(offersRoute)],
    exports: [RouterModule]
})
export class OffersRoutingModule {
}
